module.exports = __webpack_public_path__ + "static/media/bot-lascano.5f215aae.png";